import React, { Fragment } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

import { Button, ButtonTypes } from 'src/presentation/components/agent_desktop_components';
import { selectChildThreads, selectCurrentThread } from '../actions/threadsUiSlice';
import ModalWrapper from './ModalWrapper';
import { enableThread } from '../actions/threadActions';

export const HasActiveChildrenModal = ({ modalRef, root, thread }) => {
  const dispatch = useDispatch();
  const parentThreads = useSelector(selectChildThreads);
  const currentThread = useSelector(selectCurrentThread);

  const handleCloseStopInactivateModal = () => {
    modalRef.current?.close();
  };

  const handleDeactivateThread = () => {
    dispatch(enableThread({ threadId: (thread || currentThread).id, enabled: false, ignorePivots: true }));
    modalRef.current?.close();
  };

  if (modalRef.current !== null && !parentThreads) {
    return null;
  }

  return (
    <ModalWrapper
      ref={modalRef}
      title="Set as inactive"
      content={
        <div>
          <ModalTextWrapper>
            <p>
              <strong>{`${(thread || currentThread)?.name}`}</strong>{' '}
              {` pivots from ${parentThreads?.length === 1 ? 'this Thread' : 'these Threads'}:`}
              <br />
              {parentThreads?.map(parent => (
                <Fragment key={parent.id}>
                  <StyledLink to={`${root}/${parent.id}`} target="_blank">
                    {parent.name}
                  </StyledLink>
                  <br />
                </Fragment>
              ))}
            </p>
          </ModalTextWrapper>
          <Actions>
            <Button
              buttonType={ButtonTypes.SECONDARY}
              data-aid="confirmOrCancelModal-cancel"
              onClick={handleCloseStopInactivateModal}
            >
              Close
            </Button>
            <Button
              buttonType={ButtonTypes.PRIMARY}
              data-aid="confirmOrCancelModal-ok"
              onClick={handleDeactivateThread}
            >
              Set as inactive
            </Button>
          </Actions>
        </div>
      }
    />
  );
};

const Actions = styled.div`
  display: flex;
  justify-content: end;
  padding: ${p => p.theme.spacing.insetMedium};
  border-top: 1px solid ${p => p.theme.colors.gray200};
  gap: ${p => p.theme.spacing.inlineMedium};
`;

const ModalTextWrapper = styled.div`
  text-align: left;
  padding: 0 24px 24px 24px;
`;

const StyledLink = styled(Link)`
  color: ${p => p.theme.colors.green400};
  text-decoration: none;
  &:hover {
    text-decoration: underline;
  }
`;
